module.exports = "//static.hsappstatic.net/ContentComponents/static-2.63389/img/website-page-zero.svg"